import { render } from "./ClosedReport.vue?vue&type=template&id=76dc0a11"
import script from "./ClosedReport.vue?vue&type=script&lang=js"
export * from "./ClosedReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__